import { useState } from 'react';
import AppRow from './AppRow';
import { groupApps } from './groupApps';
import Chevron from '../ui/Chevron';

// IT apps checklist (spec §4.3): its open groups (Close manually, Remove paid
// seat) sit right after Needs closing, and resolved items join Closed, created
// here when no Google app is closed yet. Google grouping itself is unchanged.
function withItGroups(groups, itGroups, itClosed) {
  const at = groups.findIndex((g) => g.key === 'needs-closing') + 1;
  const open = itGroups.filter((g) => g.items.length > 0)
    .map((g) => ({ key: g.key, label: g.label, primary: true, apps: [], items: g.items }));
  let out = [...groups.slice(0, at), ...open, ...groups.slice(at)];
  if (itClosed.length > 0) {
    const ci = out.findIndex((g) => g.key === 'closed');
    if (ci >= 0) out = out.map((g, i) => (i === ci ? { ...g, items: itClosed } : g));
    else {
      const oi = out.findIndex((g) => g.key === 'other');
      const pos = oi >= 0 ? oi : out.length;
      out = [...out.slice(0, pos), { key: 'closed', label: 'Closed', primary: false, apps: [], items: itClosed }, ...out.slice(pos)];
    }
  }
  return out;
}

/**
 * The grouped list. Primary groups (Connected / Needs closing) are plain
 * headed lists; the other group is a disclosure, collapsed until a search is
 * active or a filter pill is chosen (both open every group that has matches).
 */
export default function AppGroups({ apps, itView, searching, rowProps, disclosureRefs, suffixes = {}, itGroups = [], itClosed = [], renderItRow }) {
  const [open, setOpen] = useState({});
  const google = groupApps(apps, { itView }).map((g) => ({ ...g, items: [] }));
  const groups = itView && renderItRow ? withItGroups(google, itGroups, itClosed) : google;
  return groups.map((g) => {
    const title = `${g.label} (${g.apps.length + g.items.length})`;
    const list = (
      <ul className="ca-list">
        {g.apps.map((a) => <AppRow key={a.id} app={a} suffix={suffixes[a.id]} {...rowProps} />)}
        {g.items.map((item) => renderItRow(item))}
      </ul>
    );
    if (g.primary) {
      return (
        <div key={g.key} className="ca-group" data-group={g.key}>
          <h3 className="ca-group__title" tabIndex={-1}>{title}</h3>
          {list}
        </div>
      );
    }
    const expanded = searching || !!open[g.key];
    return (
      <div key={g.key} className="ca-group" data-group={g.key}>
        {/* A search opens every group with matches, so the toggle does nothing
            then: say so rather than leave a button that looks live. */}
        <button type="button" ref={(el) => { if (el) disclosureRefs.current[g.key] = el; else delete disclosureRefs.current[g.key]; }} className="btn btn-secondary btn-small ca-disclosure" aria-expanded={expanded}
          aria-disabled={searching || undefined}
          onClick={() => { if (!searching) setOpen((o) => ({ ...o, [g.key]: !o[g.key] })); }}><Chevron className="ca-disclosure__chevron" />{title}</button>
        {expanded && list}
      </div>
    );
  });
}
